import { $ApiErrorsModuleName } from "./modules/api/errors/errors.types";
import { $LoadingModuleName } from "./modules/api/loading/loading.types";
import {
    $ApiModuleName,
    $DataModuleName,
    $ValueModuleName,
    IState
} from "./store.types";

export const formatSingleContants = (
    prefix: string,
    namespace: string,
    key: string
) => {
    return `${prefix}/${namespace}/${key.toLowerCase()}`;
};

export const createConstants = <S, K extends object>(
    stages: K,
    prefix: string,
    namespace: Extract<keyof S, string>
) =>
    Object.keys(stages).reduce(
        (accumulator, current) => ({
            ...accumulator,
            [current.toUpperCase()]: formatSingleContants(
                prefix,
                namespace,
                current
            )
        }),
        {} as { [X in keyof K as Uppercase<string & X>]: string }
    );

export const getApiDataState = <K extends keyof IState["api"]["data"]>(
    state: IState,
    namespace: K
) => state[$ApiModuleName]?.[$DataModuleName]?.[namespace];

export const getValueState = <K extends keyof IState["value"]>(
    state: IState,
    namespace: K
) => state[$ValueModuleName]?.[namespace];

export const getApiLoadingState = <K extends keyof IState["api"]["loading"]>(
    state: IState,
    namespace: K
) => state[$ApiModuleName]?.[$LoadingModuleName]?.[namespace];

export const getApiErrorsState = <K extends keyof IState["api"]["errors"]>(
    state: IState,
    namespace: K
) => state[$ApiModuleName]?.[$ApiErrorsModuleName]?.[namespace];

export const getApiErrorsStateForKey = <
    K extends keyof IState["api"]["errors"]
>(
    state: IState,
    namespace: K
) => state[$ApiModuleName]?.[$ApiErrorsModuleName]?.[namespace];
